module.exports = __webpack_public_path__ + "account/assets/ref-reload-icon.175a6f9f.svg";